<template>
    <v-btn text icon @click.stop="dialog = true;">
      <v-icon>mdi-share-variant</v-icon>

      <v-dialog v-model="dialog" persistent max-width="500">
        <ValidationObserver ref="observer" v-slot="{ }">
          <v-card>
            <v-card-title class="headline">Qual email receberá o compartilhamento?</v-card-title>

            <v-card-text>
              <v-container class="pa-0">
                <v-row>
                  <v-col>
                    <mb-input-text
                      v-model="email"
                      name="email"
                      label="Email"
                      rules="required|email"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-btn color="primary" text @click="share" :loading="loading">
                Compartilhar
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn color="secondary" text @click="cancel">
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </ValidationObserver>
      </v-dialog>
    </v-btn>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import bus from '@/plugins/eventBus';
import MbInputText from '@/components/general/inputs/MbInputText';

export default {
  props: {
    professionalId: {
      type: Number,
    },
    calendarId: {
      type: Number,
    },
  },
  data: () => ({
    dialog: false,
    loading: false,
    email: null,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.dialog = this.value;
  },
  destroyed() {
    this.dialog = false;
    this.loading = false;
    this.email = null;
    this.$emit('input', false);
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit('input', false);
    },
    async share() {
      const isValid = await this.$refs.observer.validate();
      if (this.professionalId && isValid) {
        this.loading = true;
        this.$store
          .dispatch('patientProfessionals/share', {
            patientId: this.user.id,
            professionalId: this.professionalId,
            email: this.email,
          })
          .then(() => {
            bus.$emit('message', {
              message: 'Profissional compartilhado com sucesso!',
              type: 'success',
            });
            this.dialog = false;
            this.$emit('input', false);
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.loading = true;
          });
      }
    },
  },
  watch: {
    value(vl) {
      this.dialog = vl;
    },
  },
  components: {
    ValidationObserver,
    MbInputText,
  },
};
</script>
